import { computed, Injectable, signal } from '@angular/core';
import type { Layer } from 'leaflet';

@Injectable({
  providedIn: 'root',
})
export class SearchResultService {
  readonly searchResults = signal<Record<string, Layer>>({});
  readonly hasSearchResults = computed(
    () => Object.values(this.searchResults()).length,
  );

  public addSearchResult(id: string, result: Layer) {
    this.searchResults.update((results) => ({
      ...results,
      [id]: result,
    }));
  }

  public removeSearchResult(id: string) {
    this.searchResults.update((results) => {
      delete results[id];
      return { ...results };
    });
  }

  public clearSearchResults() {
    this.searchResults.set({});
  }

  public replaceSearchResult(id: string, result: Layer) {
    this.clearSearchResults();
    this.addSearchResult(id, result);
  }
}
